import axios from "axios";
import Footer from "./Footer";
import NavBar from "./NavBar";
import { useEffect, useState } from "react";
import CardPlanosEmpresariais from "./CardPlanoEmpresariais";
import { useLocation, useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import Loading from "./Loading";
import { motion } from "framer-motion";

export default function PlanosEmpresariais() {
  const [planosEmpresas, setPlanoEmpresas] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  async function mostrarCardPlanosEmpresariais() {
    try {
      setLoading(true);
      const token = JSON.parse(localStorage.getItem("token"));
      const dados = await axios.get(
        "https://api-eyazs-production-8f74.up.railway.app/planosempresariais",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (dados.data) {
        setPlanoEmpresas([...dados.data]);
      } else {
        console.log("Não há planos disponíveis");
      }
      setLoading(false);
    } catch (erro) {
      console.log(erro);
      setLoading(false);
    }
  }

  useEffect(() => {
    mostrarCardPlanosEmpresariais();
  }, []);

  return (
    <div className="flex h-screen flex-col justify-between">
      {/* NavBar */}
      <div className="bg-blue-500 text-gray-200 w-full sticky top-0 z-10">
        <NavBar />
      </div>

      {loading ? (
        <div className="z-0">
          <Loading />
        </div>
      ) : (
        <div>
          <motion.button
            className="group"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => navigate(-1)}
          >
            <div className="flex ml-4 mt-4 md:flex lg:hidden">
              <div>
                <ChevronLeft className="group-hover:font-semibold text-black" />
              </div>
              <div>
                <span className="text-sm text-black group-hover:font-semibold">
                  Voltar
                </span>
              </div>
            </div>
          </motion.button>

          {/* Conteúdo Principal */}
          <div className="w-[90%] px-4 sm:px-6 md:px-8 lg:px-16 xl:px-20 mx-auto my-6 z-0">
            <div className="flex flex-wrap justify-center gap-6">
              {planosEmpresas.map((plano, index) => (
                <motion.div
                  key={plano.id}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                >
                  <CardPlanosEmpresariais
                    id={plano.id}
                    descricao={plano.descricao}
                    validade={plano.validade}
                    preco={plano.preco}
                    titulo={plano.plano}
                    queryString={location.search}
                    className="w-full sm:w-[48%] md:w-[45%] lg:w-[30%]"
                  />
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Footer */}
      <div className="bg-blue-500 text-gray-200 w-full">
        <Footer />
      </div>
    </div>
  );
}
